module.exports = __webpack_public_path__ + "img/Vector(1).2b338486.svg";